import allZhJson from "./zh";
import allMsJson from "./ms";
import allEnJson from "./en";
import allRuJson from "./ru";
import allFrJson from "./fr";
import allKmJson from "./km";
import allPtJson from "./pt";



export const allTranslationJson = {
    zh: {
        ...allZhJson,
    },
    ms: {
        ...allMsJson,
    },
    en: {
        ...allEnJson,
    },
    ru: {
        ...allRuJson,
    },
    fr: {
        ...allFrJson,
    },
    km: {
        ...allKmJson,
    },
    pt: {
        ...allPtJson
    }
};
